<template>
	<router-view/>
</template>

<script>


export default {
	name: 'Icons'
}
</script>

<style lang="scss" scoped>
</style>




// WEBPACK FOOTER //
// src/views/ui/Icons/Icons.vue